import { sharedChargeSchema } from 'templates/Charge/sharedCharge.schema'
import * as yup from 'yup'

import {
  SIMPLIFIED_CHECKOUT_BOLETO_ERROR,
  paymentsRequireAddress
} from './simplifiedCheckout'

// Schema específico do payment link (campos não compartilhados)
const paymentLinkSpecificSchema = yup.object().shape({
  // Campos específicos do payment link
  title: yup.string(),
  customerType: yup.string().optional(),
  customer: yup.object().optional(),
  customerUuid: yup.string().when('customerType', {
    is: 'existing',
    then: yup
      .string()
      .required('Cliente obrigatório quando tipo é "cliente existente".'),
    otherwise: yup.string().optional()
  }),
  hasExtraFields: yup.boolean().optional(),
  hasCustomerGroups: yup.boolean().optional(),
  groupsValue: yup.array().when('hasCustomerGroups', {
    is: true,
    then: yup.array().min(1, 'Selecione pelo menos um grupo de clientes.'),
    otherwise: yup.array().optional()
  }),
  hasCustomMessage: yup.boolean().optional(),
  customMessage: yup.string().when('hasCustomMessage', {
    is: true,
    then: yup.string().required('Mensagem personalizada é obrigatória.'),
    otherwise: yup.string().optional()
  }),
  hasCustomUrl: yup.boolean().optional(),
  customUrl: yup.string().when('hasCustomUrl', {
    is: true,
    then: yup
      .string()
      .url('URL inválida.')
      .required('URL de redirecionamento é obrigatória.'),
    otherwise: yup.string().optional()
  }),
  hasCustomDomain: yup.boolean().optional(),
  customDomain: yup.string().when('hasCustomDomain', {
    is: true,
    then: yup.string().required('Domínio personalizado é obrigatório.'),
    otherwise: yup.string().optional()
  }),
  sendWelcomeEmail: yup.boolean().optional(),
  simplifiedCheckout: yup
    .boolean()
    .optional()
    .default(false)
    // `payments` vem do sharedChargeSchema concatenado abaixo, por isso a regra
    // é um .test lendo o irmão em runtime e não um .when declarativo.
    .test(
      'simplified-checkout-requires-no-boleto',
      SIMPLIFIED_CHECKOUT_BOLETO_ERROR,
      function (value) {
        if (!value) return true
        // O switch só é renderizado para cliente novo; fora daí não há controle
        // visível para o merchant desligar, então bloquear travaria o save sem
        // saída. Esse caminho é fechado por resolveSimplifiedCheckoutPayload,
        // que zera a flag no payload — não deixe um sem o outro.
        if (this.parent?.customerType !== 'new') return true
        return !paymentsRequireAddress(this.parent?.payments)
      }
    ),
  canChangeCheckoutQuantity: yup.boolean().optional(),
  // Campo apagado chega como "": vira undefined em vez do erro cru de NaN do yup.
  defaultQuantity: yup
    .number()
    .transform((value, originalValue) =>
      originalValue === '' || originalValue === null ? undefined : value
    )
    .optional(),
  emails_to_notify: yup.array().of(
    yup.object({
      email: yup
        .string()
        .email('E-mail inválido')
        .required('E-mail é obrigatório')
    })
  ),
  // Person Type (Tipo de Cliente)
  link_type: yup
    .string()
    .oneOf(['PF', 'PJ', 'BOTH'], 'Tipo de Cliente inválido')
    .default('BOTH'),
  // Contacts (Contatos)
  contacts_enabled: yup.boolean().optional(),
  contacts: yup.array().of(
    yup.object({
      type: yup.string().required('Selecione o tipo do contato.'),
      required: yup.boolean().default(false)
    })
  ),
  // Existing document behavior (Comportamento no caso de cliente existente)
  // SC-10380: default é update_customer (2)
  existing_document_behavior: yup
    .number()
    .oneOf([0, 1, 2], 'Comportamento inválido')
    .default(2),

  consider_active_on_registration: yup.boolean().optional().default(false),

  cancel_if_first_billing_unpaid: yup.boolean().optional().default(false),

  hasContract: yup.boolean().default(false),
  contractModelUuid: yup.string().nullable().optional(),
  contractBillingBehavior: yup.string().default('contract_and_billing')
})

// Schema combinado para payment link
const createPaymentLinkSchema =
  paymentLinkSpecificSchema.concat(sharedChargeSchema)

export default createPaymentLinkSchema
